import { memoizedGet as get } from './object'
import useResponsiveValue from '../hooks/use-responsive-value'
import type { Theme } from '../theme-provider/types'
import { useSafeThemeUI } from '../theme-provider/use-theme-ui'
import {
  largeResponsiveSizes,
  mediumResponsiveSizes,
  smallResponsiveSizes,
  standardResponsiveSizes,
  xLargeResponsiveSizes,
  xSmallResponsiveSizes,
  xxLargeResponsiveSizes
} from '../themes/const'
import type { Size } from '../themes/types'
import { isSizeKey } from '../themes/types'

function getBodyFont(
  fontType: 'xs' | 'sm' | 'std' | 'md' | 'lg' | 'xl' | 'xxl'
) {
  switch (fontType) {
    case 'xs':
      return xSmallResponsiveSizes
    case 'sm':
      return smallResponsiveSizes
    case 'std':
      return standardResponsiveSizes
    case 'md':
      return mediumResponsiveSizes
    case 'lg':
      return largeResponsiveSizes
    case 'xl':
      return xLargeResponsiveSizes
    case 'xxl':
      return xxLargeResponsiveSizes
  }
}

export default function (
  fontType:
    | 'xs'
    | 'sm'
    | 'std'
    | 'md'
    | 'lg'
    | 'xl'
    | 'xxl'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6',
  size?: Size,
  theme?: Theme
): [string, string] {
  const _theme = useSafeThemeUI({ theme })

  const sizes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(fontType)
    ? get(_theme, `headings.${fontType}.fontSize`)
    : // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getBodyFont(fontType as any)

  const value = size
    ? (get(_theme, `sizes.font.${size}`) as number)
    : useResponsiveValue<number>(sizes)
  const retVal = isSizeKey(`${value}`)
    ? get(_theme, `fontSizes.${get(_theme, `sizes.font.${value}`)}`)
    : get(_theme, `fontSizes.${value}`)
  return [retVal, `${value}`]
}
